<button
  [attr.data-theme]="theme()"
  [class.focus]="focus()"
  class="flex items-center w-full gap-2 p-2 transition-all outline-none cursor-pointer select-none hover:bg-gray-50 hover:rounded-lg option theme-text min-w-24 theme-hover"
>
  <div class="flex items-center">
    @if (icon(); as icon) {
    <app-icon
      size="sm"
      [attr.data-theme]="theme()"
      [name]="icon"
      class="theme-text"
    />
    }
  </div>
  <ng-content />
  @if (active()) {
  <app-icon
    [attr.data-theme]="theme()"
    name="mdi:check"
    size="sm"
    class="theme-text"
  />
  }
</button>
